//local
//export const urlAdmin = "http://localhost:3000/";

//dev
//export const urlAdmin = "https://hrm-ddif.dev.smartdanang.vn/";

//publish
export const urlAdmin = "https://qldh.ddif.com.vn/";

export const responseStatus = {
    thanhCong: 1,
    loi: 0
};

export const logoColor = {
    xanh: "#0c4da2",
    cam: "#F58220",
};

//export const urlAPI = "https://localhost:7094/"; // local
//export const urlAPI = "https://hrm-ddif.dev.smartdanang.vn/api/"; // dev
export const urlAPI = "https://qldh-api.ddif.com.vn/"; // publish
export const searchLength = 10;
export const idQuyDauTu = 1;
export const searchLengthNguoiDung = 5;
export const noData = "Không có dữ liệu";

export const datePlaceholder = 'ngày/tháng/năm';
export const dateFormat = 'dd/MM/yyyy';
export const formatTime = 'HH:mm';

export const kieu_DangNhap = {
    binhThuong: 0,
    SSO: 1,
}
export const loaiNgoaiGio = {
    ngayThuong: 1,
    cuoiTuan: 2,
    ngayLe: 3,
}
export const loaiLanhDaoPhuTrach = {
    tatCa: 0,
    phuTrach1: 1,
    phuTrach2: 2
}
export const defaultAvatarImg = "/img/profile.png"
export const trangThaiKPI = {
    khoiTao: 0,
    thuHoi: 1,
    lanhDaoPhongTuChoi: 2,
    trinhLanhDaoPhong: 3,
    lanhDaoPhuTrachTuChoi: 4,
    trinhLanhDaoPhuTrach: 5,
    lanhDaoDonViTuChoi: 6,
    trinhLanhDaoDonVi: 7,
    pheDuyet: 8,
};

export const trangThaiKPITongHop = {
    khoiTao: 0,
    thuHoi: 1,
    trinhPhoCVP: 2,
    phoCVPTraLai: 3,
    trinhCVP: 4,
    chanhVPTraLai: 5,
    trinhGiamDoc: 6,
    giamDocTraLai: 7,
    pheDuyet: 8,
};

export const trangThaiHopDongDienTu = {
    khoiTao: 0,
    thuHoi: 1,
    nguoiKyNhayTraLai: 2,
    trinhNguoiKyNhay: 3,
    chuyenNhanVien: 4,
    chuyenNguoiKyNhay: 5,
    chuyenGiamDoc: 6,
    chuyenVanThu: 7,
    hoanThanh: 8,
    kichHoat: 9
};
export const trangThaiLopDaoTao = {
    chuaKhoiTao: -1,
    khoiTao: 0,
    thuHoi: 1,
    trinhPhoCVP: 2,
    phoCVPTraLai: 3,
    trinhCVP: 4,
    chanhVPTraLai: 5,
    trinhPhoGiamDoc: 6,
    phoGiamDocTraLai: 7,
    trinhGiamDoc: 8,
    giamDocTraLai: 9,
    pheDuyet: 10,
    hoanThanh: 11,
};

export const trangThaiTongHopDangKyDaoTao = {
    khoiTao: 0,
    thuHoi: 1,
    trinhPhoCVP: 2,
    phoCVPTraLai: 3,
    trinhCVP: 4,
    chanhVPTraLai: 5,
    trinhPhoGiamDoc: 6,
    phoGiamDocTraLai: 7,
    trinhGiamDoc: 8,
    giamDocTraLai: 9,
    pheDuyet: 10,
    banHanh: 11,
};

export const trangThaiDangKyDaoTao = {
    chuaDangKy: -1,
    khoiTao: 0,
    thuHoi: 1,
    trinhLanhDaoPhong: 3,
    lanhDaoPhongTuChoi: 2,
    duyetCapPhong: 4,
    chuyenVanPhong: 5,
    lanhDaoQuyTuChoi: 6, // đổi thành lãnh đạo Quỹ từ chối
    trinhPhoGiamDoc: 9,
    phoGiamDocTuChoi: 10,
    trinhGiamDoc: 11,
    giamDocTuChoi: 11,
    pheDuyet: 8,
};

export const maChucVu = {
    giamDoc: "GD",
    vanThu: "VT",
    phoGiamDoc: "PGD",
    phoCVP: "PCVP",
    chanhVP: "CVP"
};

export const trangThaiDonNghiPhep = {
    khoiTao: 0,
    trinh: 1,
    daDuyet: 2,
    tuChoi: 3,
    yKien: 4,
    yeuCauHuy: 5,
    daHuy: 6,
}

export const trangThaiDonNgoaiGio = {
    khoiTao: 0,
    trinh: 1,
    daDuyet: 2,
    tuChoi: 3,
    yKien: 4
}

export const trangThaiChamCong = {
    khoiTao: 0,
    thuHoi: 3,
    trinhLDPhong: 4,
    lDPhongTraLai: 5,
    trinhLDPhuTrach: 1,
    lDPhuTrachTraLai: 6,
    lDPhuTrachDuyet: 2
}

export const trangThaiChamCongTongHop = {
    khoiTao: 0,
    thuHoi: 1,
    trinhPhoCVP: 2,
    phoCVPTraLai: 3,
    trinhCVP: 4,
    chanhVPTraLai: 5,
    trinhGiamDoc: 6,
    giamDocTraLai: 7,
    pheDuyet: 8,
};

export const trangThaiLogNguoiDung = {
    luu: 0,
    trinh: 1,
    khongDuyet: 2,
    duyet: 3,
    yKien: 4
}

export const idNhomKPI = {
    chuyenMon: 1,
    noiQuy: 2,
    diemCong: 3,
};
export const kieuDanhGiaKPI = {
    tuDanhGia: 0,
    lanhDaoDanhGia: 1,
    lanhDaoPhuTrachDanhGia: 2,
};
export const diemXepLoaiKPI = {
    chuaXepLoai: 0,
    aPlus: 1,
    a: 2,
    b: 3,
    c: 4,
};
export const chatLuongKPI = {
    tot: 1,
    saiSot: 0,
};
export const tienDoKPI = {
    truoc: 0,
    dung: 1,
    tre: 2,
    loi: 3,
    dangThucHien: 4,
    khongCo: 5
};

export const layTenTienDoKPI = (tienDo) => {
    switch (tienDo) {
        case tienDoKPI.truoc: return "Trước";
        case tienDoKPI.dung: return "Đúng";
        case tienDoKPI.tre: return "Trễ ";
        case tienDoKPI.loi: return "Lỗi";
        case tienDoKPI.dangThucHien: return "Đang TH";
        case tienDoKPI.khongCo: return "";
        default: return "";
    }
};

export const loaiThongBao = {
    donThemGio: 1,
    donNghiPhep: 2,
    chamCongThang: 3,
    chamNgoaiGio: 4,
    kpi: 5,
    yKienKPI: 15,
    congViec: 6,
    giaoViec: 7,
    tongHopChamCong: 8,
    hopDong: 9,
    quyetDinhBacLuong: 10,
    tongHopKPI: 11,
    dangKyDaoTao: 12,
    tongHopDKDT: 13,
    banGiaoTaiSan: 14,
    kiemKeTaiSan: 16,
    lopDaoTao: 17,
    hopDongDienTu: 18,
};

export const trangThaiCongViec = {
    khoiTao: 0,
    dangThucHien: 1,
    daHoanThanh: 2,
}

export const loaiNghiPhep = {
    nghiPhep: 1,
    nghiThaiSan: 2,
    nghiOm: 3,
    nghiBHXH: 4,
    nghiKhongLuong: 5,
};
export const loaiNgayNghi = {
    nghiLe: 1,
    nghiBu: 2,
    lamBu: 3,
    hoanDoi: 4
};

export const trangThaiKhoaLuong = {
    chuaKhoa: 1,
    khoa: 2,
}

export const phongBan = {
    banGiamDoc: 2,
    vanPhong: 10,
    keToan: 17
}

export const chucVu = {
    chanhVanPhong: 11,
    giamDoc: 2
}

export const loaiLuongThanhPhan = {
    luongBs_NQL: 1, //lương bổ sung Ng Quản lý
    luongTT_NLD: 2, //lương tăng thêm Ng Lao động
    luongPhatSinh: 3, //lương phát sinh, quỹ ủng hộ
    luongNDD: 4, //thù lao người đại diện
    BHXH: 5, //thù lao người đại diện
    luongThang: 6, //lương tháng
    thuLaoKCT: 7,
    phuCapTGV: 8,
    luongKhenThuongNSK: 9,
    luongThemGio: 10,
    thueThanhPhan: 11,
    thueTNCN_ThamChieu: 12,
    thueKTX_ThamChieu: 13
}

export const loaiCapNhatTB = {
    daXem: 1,
    daXuLy: 2
}

export const loaiChuKyThue = {
    thang: 1,
    quy: 2,
    nam: 3
}

export const kieuTinhThue = {
    tamTinh: 1,
    dieuChinh: 2
}

export const trangThaiThue = {
    khoiTao: 0,
    duyet: 1
}

export const loaiThue = {
    thuongXuyen: 1,
    khongThuongXuyen: 2,
    tongHop: 3
}

export const soNgayCongMacDinh = 22;